import React from 'react';

export const ContainerInput = ({children}) => {
    return (
        <div className="relative w-full mb-3">
            {children}
        </div>
    );
};


